/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useState } from "react";
import { ReactComponent as BuildingIcon } from "cms/assets/icons/building.svg";
import { ReactComponent as ClockIcon } from "cms/assets/icons/clock.svg";
import { ReactComponent as EmailIcon } from "cms/assets/icons/email.svg";
import { ReactComponent as PhoneIcon } from "cms/assets/icons/phone.svg";
import { ReactComponent as FaxIcon } from "cms/assets/icons/fax.svg";

function FooterContact () {

    const FAX_NUMBER = "250-632-4995";

    const [copied, setCopied] = useState(false);

    const handleCopyFax = (e) => {
        e.preventDefault();
        navigator.clipboard.writeText(FAX_NUMBER);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };

    return (
        <div className="footer-contact footer-column">
            <h3 className="footer-column-title">Contact Us</h3>
            <ul className="footer-column-content">
                <li>
                    <BuildingIcon alt="building" />
                    <p>270 City Centre<br />Kitimat, BC, V8C 2H7</p>
                </li>
                <li>
                    <ClockIcon alt="clock" />
                    <p>Monday to Friday,<br />8:30 a.m. to 4:30 p.m.<br />(closed holidays)</p>
                </li>
                <li>
                    <EmailIcon alt="email"/>
                    <a href="mailto:info@kitimat.ca">info@kitimat.ca</a>
                </li>
                <li>
                    <PhoneIcon alt="phone" />
                    <a href="tel:2506328900">250-632-8900</a>
                </li>
                <li>
                    <FaxIcon alt="fax" />
                    <a href="#" onClick={handleCopyFax}>{FAX_NUMBER}</a>
                    {copied && <span className="copied-toast">Copied to clipboard</span>}
                </li>
            </ul>
        </div>
    );
}

export { FooterContact };
